import { render, staticRenderFns } from "./CardProjectDemo.vue?vue&type=template&id=bf5e6146&"
import script from "./CardProjectDemo.vue?vue&type=script&lang=js&"
export * from "./CardProjectDemo.vue?vue&type=script&lang=js&"
import style0 from "./CardProjectDemo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports